import PropTypes from 'prop-types';
// @mui
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';
import { approveMaintenanceRecord } from '../store/maintenanceActions';

Accept.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  maintenanceId: PropTypes.string,
};

export default function Accept({ open, handleClose, maintenanceId }) {
  const dispatch = useDispatch();

  const { isLoading } = useSelector((state) => state.maintenanceReducer);

  const handleApproveMaintenance = async () => {
    const values = { record_status: 'APPROVED', remarks: '' };
    const payload = {
      id: maintenanceId,
      payload: values,
    };
    dispatch(approveMaintenanceRecord(payload));
    handleClose();
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'You are about to approve maintenance request.'}</DialogTitle>
      <DialogActions>
        <Button size="small" variant="contained" color="error" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          type="submit"
          size="small"
          variant="contained"
          loading={isLoading}
          onClick={handleApproveMaintenance}
        >
          Proceed
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
